export default {
    filters: {
        title(value) {
            if (value !== null && value !== undefined) {
                return value
                    .toLowerCase()
                    .split(' ')
                    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
                    .join(' ');
            }
            return ' - ';
        },
        customTitle(value, character) {
            if (value !== null && value !== undefined) {
                return value
                    .toLowerCase()
                    .split(character)
                    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
                    .join(' ');
            }
            return ' - ';
        },
        phoneFormat(value) {
            let a = `(${value.slice(0, 3)}) ${value.slice(3)}`;
            a = `${a.slice(0, 9)} - ${a.slice(9)}`;
            return a;
        },
        timeFormat(value) {
            let a = `${value.slice(0, 2)}:${value.slice(2, 4)}`;
            a = `${a.slice(0, 3)} - ${a.slice(3)}`;
            return a;
        },
        header(value) {
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
    },
};
